import { defineWidgets } from "../utils/defineWidgets.ts";

export const widgets = defineWidgets({
  "ld-tennis-sdapi-calendar": () => import("./sdapi-calendar/calendar.tsx"),
  "ld-tennis-sdapi-live-score": () => import("./sdapi-live-score/live-score.tsx"),
  "ld-tennis-sdapi-ranking": () => import("./sdapi-ranking/ranking.tsx"),
  "ld-tennis-sdapi-results": () => import("./sdapi-results/results.tsx"),
  "ld-tennis-sdapi-results-categories": () => import("./sdapi-results-categories/results-categores.tsx"),
  "ld-tennis-sdapi-results-container": () => import("./sdapi-results-container/results-container.tsx"),
});
